<template>
  <div>
    <div v-if="forConasi" class="my-3">
      <router-view />
    </div>
    <div v-else class="container-fluid my-3">
      <div class="d-flex flex-nowrap row wrap-container">
        <div class="column">
          <router-view />
        </div>
        <div class="column right-pane">
          <img
            src="../../assets/account-pane.png"
            alt=" "
            class="img-responsive"
            style="margin: 1em; width: 250px"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FOR_CONASI_TARGET } from 'Utils/constants'
export default {
  data: () => ({
    forConasi: FOR_CONASI_TARGET
  })
}
</script>

<style lang="scss" scoped>
@import "@/styles/color.scss";
.container-fluid {
  // background-color: rgba(255, 0, 0, 0.39);
  display: flex; justify-content:
  center; align-items: center;
}
.wrap-container {
  background-color:rgba(255, 255, 255, 0.8);
  border: 1px;
  border-radius: 7px;
  border: 1px solid #036fb7a6;
}

* {
  box-sizing: border-box;
}

.right-pane {
  justify-content: center;
  align-items: center;
  border: 0;
  border-left: 1px;
  border-color: lightgray;
  border-style: solid;
}

/* Create two equal columns that floats next to each other */
.column {
  float: left;
  width: auto;
  padding: 10px;
}

/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}

/* Responsive layout - makes the two columns stack on top of each other instead of next to each other */
@media screen and (max-width: 768px) {
  .column {
    width: 100%;
  }
  .right-pane {
    display: none;
  }
}

</style>
